import { createAsyncThunk } from "@reduxjs/toolkit";
import ModerationAPI from "./adminModerationAPI";

export const fetchAllModerationEventsThunk = createAsyncThunk(
  "moderation/fetchAll",
  async ({ skip = 0, limit = 50, status, type, reason, search } = {}, { rejectWithValue }) => {
    try {
      return await ModerationAPI.fetchAllEvents({ skip, limit, status, type, reason, search });
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const fetchGroupModerationEventsThunk = createAsyncThunk(
  "moderation/fetchAllGroupPosts",
  async ({ skip = 0, limit = 50, status, type, reason, search } = {}, { rejectWithValue }) => {
    try {
      return await ModerationAPI.fetchGroupPostEvents({ skip, limit, status, type, reason, search });
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const fetchPostModerationEventsThunk = createAsyncThunk(
  "moderation/fetchByPost",
  async ({ postId }, { rejectWithValue }) => {
    try {
      return { postId, items: await ModerationAPI.fetchEventsByPost(postId) };
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const createManualModerationEventThunk = createAsyncThunk(
  "moderation/createManual",
  async (payload, { rejectWithValue }) => {
    try {
      return await ModerationAPI.createManualEvent(payload);
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const analyzeAndFlagThunk = createAsyncThunk(
  "moderation/analyzeAndFlag",
  async ({ post_id, user_id, content }, { rejectWithValue }) => {
    try {
      return await ModerationAPI.analyzeAndFlag({ post_id, user_id, content });
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const reanalyzePostThunk = createAsyncThunk(
  "moderation/reanalyzePost",
  async ({ postId }, { rejectWithValue }) => {
    try {
      return await ModerationAPI.reanalyzePost(postId);
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);

export const updateModerationStatusThunk = createAsyncThunk(
  "moderation/updateStatus",
  async ({ eventId, new_status, scope = "post" }, { rejectWithValue }) => {
    try {
      return await ModerationAPI.updateStatus({ eventId, new_status, scope });
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);
